import style from "./Footer.module.css"
import globals from "../../config/appconfig"

function Footer(props){
    return (
        <footer className={"noPrint ".concat(style.footer)} style={props.style}>
            <span className={"noPrint"} style={{marginLeft:"1rem"}}>© Regione Veneto</span>
            <div className={style.footerLinks}>
                <a href="/termini" className={style.footerLink}>Termini e condizioni</a>
                <a href="/privacy" className={style.footerLink}>Privacy e cookie Policy</a>
                <a href={globals["app-url-dichiarazione-accessibilita"]} className={style.footerLink}>Dichiarazione di Accessibilità</a>
            </div>
        </footer>
    )
}
export default Footer
